import React from "react";
import { useTranslation } from "react-i18next";
import LegalLayout from "./LegalLayout";

export default function Disclaimer() {
  const { i18n } = useTranslation();
  const isTh = i18n.language?.startsWith("th") ?? true;

  const sections = isTh
    ? [
        {
          h: "1. ลักษณะของเนื้อหาบนเว็บไซต์",
          p: "เนื้อหา บทความ และข้อมูลทั้งหมดที่ปรากฏบนเว็บไซต์นี้จัดทำขึ้นเพื่อให้ความรู้ทั่วไป มิใช่คำปรึกษาทางกฎหมาย ภาษี หรือบัญชีเฉพาะกรณี การตัดสินใจดำเนินการใด ๆ ควรปรึกษาทนายความหรือผู้เชี่ยวชาญที่มีใบอนุญาตก่อน",
        },
        {
          h: "2. ไม่มีการรับประกันผลคดี",
          p: "ผลของคดีแต่ละเรื่องขึ้นอยู่กับข้อเท็จจริงและพยานหลักฐานเฉพาะกรณี สำนักงานไม่รับประกันผลคดีล่วงหน้า และมิได้รับรองว่าจะชนะคดี เนื่องจากการรับประกันลักษณะดังกล่าวขัดต่อมรรยาททนายความ",
        },
        {
          h: "3. ความถูกต้องของข้อมูล",
          p: "แม้เราจะพยายามอย่างเต็มที่ในการให้ข้อมูลที่ถูกต้องและเป็นปัจจุบัน แต่กฎหมาย ระเบียบ และแนวคำพิพากษามีการเปลี่ยนแปลงอยู่เสมอ จึงไม่อาจรับประกันได้ว่าเนื้อหาทุกส่วนจะเป็นปัจจุบันที่สุดในทุกเวลา",
        },
        {
          h: "4. ลิงก์ไปยังเว็บไซต์ภายนอก",
          p: "เว็บไซต์นี้อาจมีลิงก์ไปยังเว็บไซต์ของบุคคลภายนอก สำนักงานไม่รับผิดชอบต่อเนื้อหา ความถูกต้อง หรือการปฏิบัติด้านความเป็นส่วนตัวของเว็บไซต์ดังกล่าว",
        },
        {
          h: "5. การจำกัดความรับผิด",
          p: "สำนักงานไม่รับผิดต่อความเสียหายใด ๆ ที่เกิดจากการนำข้อมูลในเว็บไซต์ไปใช้โดยมิได้ปรึกษาทนายความก่อน รวมถึงความเสียหายโดยอ้อม ความเสียหายต่อเนื่อง หรือการสูญเสียผลกำไร",
        },
        {
          h: "6. การติดต่อขอคำปรึกษาเฉพาะกรณี",
          p: "เพื่อขอคำปรึกษาที่เหมาะสมกับข้อเท็จจริงและปัญหาของท่านโดยตรง โปรดติดต่อสำนักงาน โทร. 02-276-9968 หรืออีเมล oaoffice@ornthai.com",
        },
      ]
    : [
        {
          h: "1. Nature of Content",
          p: "All content, articles, and information on this site are general knowledge — not specific legal, tax, or accounting advice for individual cases. Before taking any action, consult a licensed lawyer or qualified professional.",
        },
        {
          h: "2. No Outcome Guarantee",
          p: "Case outcomes depend on the specific facts and evidence. The firm does not guarantee results in advance and does not promise that a case will be won — such guarantees would contravene the lawyer's code of conduct.",
        },
        {
          h: "3. Accuracy of Information",
          p: "While we strive to keep information accurate and current, laws, regulations, and case law change frequently. We cannot guarantee every section is up to date at all times.",
        },
        {
          h: "4. Links to External Sites",
          p: "This site may link to third-party sites. The firm is not responsible for the content, accuracy, or privacy practices of those sites.",
        },
        {
          h: "5. Limitation of Liability",
          p: "The firm is not liable for any damages from using site information without consulting a lawyer first — including indirect, consequential, or lost-profit damages.",
        },
        {
          h: "6. Contact for Case-Specific Advice",
          p: "To get advice tailored to your facts and issues, please contact the office at +66 2-276-9968 or oaoffice@ornthai.com.",
        },
      ];

  return (
    <LegalLayout
      title={isTh ? "ข้อสงวนสิทธิและคำเตือน" : "Disclaimer"}
      subtitle={isTh ? "Legal Disclaimer" : "Legal Disclaimer"}
      lastUpdated={isTh ? "ปรับปรุงล่าสุด: 11 พฤษภาคม 2569" : "Last Updated: May 11, 2026"}
      sections={sections}
    />
  );
}
